import { dateTimeSlashesFormat } from 'App/services/DateService';
import { localize } from 'App/utils';

const formatForCell = (value) => localize(value, dateTimeSlashesFormat);

const DateFormatCell = ({ value }) => {
    return formatForCell(value);
};

export { formatForCell };

export default DateFormatCell;
